module.exports = __webpack_public_path__ + "assets/images/scrolly-v2/big.svg?v=ca5b8870";